// src/data/jnanaDeepamData.js

export const jnanaDeepamQuizzes = [
  {
    "id": "quiz-2026-10-30",
    "title": "UPSC Current Affairs Quiz – 30 October 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 October 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "OCT",
    "monthFull": "October",
    "year": "2026",
    "isLatest": true,
    "date": "2026-10-30",
    "displayDate": "30 October 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-10-29",
    "title": "UPSC Current Affairs Quiz – 29 October 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 October 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "OCT",
    "monthFull": "October",
    "year": "2026",
    "isLatest": false,
    "date": "2026-10-29",
    "displayDate": "29 October 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-10-28",
    "title": "UPSC Current Affairs Quiz – 28 October 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 October 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "OCT",
    "monthFull": "October",
    "year": "2026",
    "isLatest": false,
    "date": "2026-10-28",
    "displayDate": "28 October 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-10-27",
    "title": "UPSC Current Affairs Quiz – 27 October 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 27 October 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "27",
    "month": "OCT",
    "monthFull": "October",
    "year": "2026",
    "isLatest": false,
    "date": "2026-10-27",
    "displayDate": "27 October 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-10-26",
    "title": "UPSC Current Affairs Quiz – 26 October 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 26 October 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "26",
    "month": "OCT",
    "monthFull": "October",
    "year": "2026",
    "isLatest": false,
    "date": "2026-10-26",
    "displayDate": "26 October 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-10-25",
    "title": "UPSC Current Affairs Quiz – 25 October 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 25 October 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "25",
    "month": "OCT",
    "monthFull": "October",
    "year": "2026",
    "isLatest": false,
    "date": "2026-10-25",
    "displayDate": "25 October 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-10-24",
    "title": "UPSC Current Affairs Quiz – 24 October 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 24 October 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "24",
    "month": "OCT",
    "monthFull": "October",
    "year": "2026",
    "isLatest": false,
    "date": "2026-10-24",
    "displayDate": "24 October 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-10-23",
    "title": "UPSC Current Affairs Quiz – 23 October 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 23 October 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "23",
    "month": "OCT",
    "monthFull": "October",
    "year": "2026",
    "isLatest": false,
    "date": "2026-10-23",
    "displayDate": "23 October 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-10-22",
    "title": "UPSC Current Affairs Quiz – 22 October 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 22 October 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "22",
    "month": "OCT",
    "monthFull": "October",
    "year": "2026",
    "isLatest": false,
    "date": "2026-10-22",
    "displayDate": "22 October 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-10-21",
    "title": "UPSC Current Affairs Quiz – 21 October 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 21 October 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "21",
    "month": "OCT",
    "monthFull": "October",
    "year": "2026",
    "isLatest": false,
    "date": "2026-10-21",
    "displayDate": "21 October 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-10-20",
    "title": "UPSC Current Affairs Quiz – 20 October 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 20 October 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "20",
    "month": "OCT",
    "monthFull": "October",
    "year": "2026",
    "isLatest": false,
    "date": "2026-10-20",
    "displayDate": "20 October 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-09-30",
    "title": "UPSC Current Affairs Quiz – 30 September 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 September 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "SEP",
    "monthFull": "September",
    "year": "2026",
    "isLatest": false,
    "date": "2026-09-30",
    "displayDate": "30 September 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-09-29",
    "title": "UPSC Current Affairs Quiz – 29 September 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 September 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "SEP",
    "monthFull": "September",
    "year": "2026",
    "isLatest": false,
    "date": "2026-09-29",
    "displayDate": "29 September 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-09-28",
    "title": "UPSC Current Affairs Quiz – 28 September 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 September 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "SEP",
    "monthFull": "September",
    "year": "2026",
    "isLatest": false,
    "date": "2026-09-28",
    "displayDate": "28 September 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-09-27",
    "title": "UPSC Current Affairs Quiz – 27 September 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 27 September 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "27",
    "month": "SEP",
    "monthFull": "September",
    "year": "2026",
    "isLatest": false,
    "date": "2026-09-27",
    "displayDate": "27 September 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-09-26",
    "title": "UPSC Current Affairs Quiz – 26 September 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 26 September 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "26",
    "month": "SEP",
    "monthFull": "September",
    "year": "2026",
    "isLatest": false,
    "date": "2026-09-26",
    "displayDate": "26 September 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-09-25",
    "title": "UPSC Current Affairs Quiz – 25 September 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 25 September 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "25",
    "month": "SEP",
    "monthFull": "September",
    "year": "2026",
    "isLatest": false,
    "date": "2026-09-25",
    "displayDate": "25 September 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-09-24",
    "title": "UPSC Current Affairs Quiz – 24 September 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 24 September 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "24",
    "month": "SEP",
    "monthFull": "September",
    "year": "2026",
    "isLatest": false,
    "date": "2026-09-24",
    "displayDate": "24 September 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-09-23",
    "title": "UPSC Current Affairs Quiz – 23 September 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 23 September 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "23",
    "month": "SEP",
    "monthFull": "September",
    "year": "2026",
    "isLatest": false,
    "date": "2026-09-23",
    "displayDate": "23 September 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-09-22",
    "title": "UPSC Current Affairs Quiz – 22 September 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 22 September 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "22",
    "month": "SEP",
    "monthFull": "September",
    "year": "2026",
    "isLatest": false,
    "date": "2026-09-22",
    "displayDate": "22 September 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-09-21",
    "title": "UPSC Current Affairs Quiz – 21 September 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 21 September 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "21",
    "month": "SEP",
    "monthFull": "September",
    "year": "2026",
    "isLatest": false,
    "date": "2026-09-21",
    "displayDate": "21 September 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-09-20",
    "title": "UPSC Current Affairs Quiz – 20 September 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 20 September 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "20",
    "month": "SEP",
    "monthFull": "September",
    "year": "2026",
    "isLatest": false,
    "date": "2026-09-20",
    "displayDate": "20 September 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-08-31",
    "title": "UPSC Current Affairs Quiz – 31 August 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 31 August 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "31",
    "month": "AUG",
    "monthFull": "August",
    "year": "2026",
    "isLatest": false,
    "date": "2026-08-31",
    "displayDate": "31 August 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-08-30",
    "title": "UPSC Current Affairs Quiz – 30 August 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 August 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "AUG",
    "monthFull": "August",
    "year": "2026",
    "isLatest": false,
    "date": "2026-08-30",
    "displayDate": "30 August 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-08-29",
    "title": "UPSC Current Affairs Quiz – 29 August 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 August 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "AUG",
    "monthFull": "August",
    "year": "2026",
    "isLatest": false,
    "date": "2026-08-29",
    "displayDate": "29 August 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-08-28",
    "title": "UPSC Current Affairs Quiz – 28 August 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 August 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "AUG",
    "monthFull": "August",
    "year": "2026",
    "isLatest": false,
    "date": "2026-08-28",
    "displayDate": "28 August 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-08-27",
    "title": "UPSC Current Affairs Quiz – 27 August 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 27 August 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "27",
    "month": "AUG",
    "monthFull": "August",
    "year": "2026",
    "isLatest": false,
    "date": "2026-08-27",
    "displayDate": "27 August 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-08-26",
    "title": "UPSC Current Affairs Quiz – 26 August 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 26 August 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "26",
    "month": "AUG",
    "monthFull": "August",
    "year": "2026",
    "isLatest": false,
    "date": "2026-08-26",
    "displayDate": "26 August 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-08-25",
    "title": "UPSC Current Affairs Quiz – 25 August 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 25 August 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "25",
    "month": "AUG",
    "monthFull": "August",
    "year": "2026",
    "isLatest": false,
    "date": "2026-08-25",
    "displayDate": "25 August 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-08-24",
    "title": "UPSC Current Affairs Quiz – 24 August 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 24 August 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "24",
    "month": "AUG",
    "monthFull": "August",
    "year": "2026",
    "isLatest": false,
    "date": "2026-08-24",
    "displayDate": "24 August 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-08-23",
    "title": "UPSC Current Affairs Quiz – 23 August 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 23 August 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "23",
    "month": "AUG",
    "monthFull": "August",
    "year": "2026",
    "isLatest": false,
    "date": "2026-08-23",
    "displayDate": "23 August 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-08-22",
    "title": "UPSC Current Affairs Quiz – 22 August 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 22 August 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "22",
    "month": "AUG",
    "monthFull": "August",
    "year": "2026",
    "isLatest": false,
    "date": "2026-08-22",
    "displayDate": "22 August 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-08-21",
    "title": "UPSC Current Affairs Quiz – 21 August 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 21 August 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "21",
    "month": "AUG",
    "monthFull": "August",
    "year": "2026",
    "isLatest": false,
    "date": "2026-08-21",
    "displayDate": "21 August 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-07-31",
    "title": "UPSC Current Affairs Quiz – 31 July 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 31 July 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "31",
    "month": "JUL",
    "monthFull": "July",
    "year": "2026",
    "isLatest": false,
    "date": "2026-07-31",
    "displayDate": "31 July 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-07-30",
    "title": "UPSC Current Affairs Quiz – 30 July 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 July 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "JUL",
    "monthFull": "July",
    "year": "2026",
    "isLatest": false,
    "date": "2026-07-30",
    "displayDate": "30 July 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-07-29",
    "title": "UPSC Current Affairs Quiz – 29 July 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 July 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "JUL",
    "monthFull": "July",
    "year": "2026",
    "isLatest": false,
    "date": "2026-07-29",
    "displayDate": "29 July 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-07-28",
    "title": "UPSC Current Affairs Quiz – 28 July 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 July 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "JUL",
    "monthFull": "July",
    "year": "2026",
    "isLatest": false,
    "date": "2026-07-28",
    "displayDate": "28 July 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-07-27",
    "title": "UPSC Current Affairs Quiz – 27 July 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 27 July 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "27",
    "month": "JUL",
    "monthFull": "July",
    "year": "2026",
    "isLatest": false,
    "date": "2026-07-27",
    "displayDate": "27 July 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-07-26",
    "title": "UPSC Current Affairs Quiz – 26 July 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 26 July 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "26",
    "month": "JUL",
    "monthFull": "July",
    "year": "2026",
    "isLatest": false,
    "date": "2026-07-26",
    "displayDate": "26 July 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-07-25",
    "title": "UPSC Current Affairs Quiz – 25 July 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 25 July 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "25",
    "month": "JUL",
    "monthFull": "July",
    "year": "2026",
    "isLatest": false,
    "date": "2026-07-25",
    "displayDate": "25 July 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-07-24",
    "title": "UPSC Current Affairs Quiz – 24 July 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 24 July 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "24",
    "month": "JUL",
    "monthFull": "July",
    "year": "2026",
    "isLatest": false,
    "date": "2026-07-24",
    "displayDate": "24 July 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-07-23",
    "title": "UPSC Current Affairs Quiz – 23 July 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 23 July 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "23",
    "month": "JUL",
    "monthFull": "July",
    "year": "2026",
    "isLatest": false,
    "date": "2026-07-23",
    "displayDate": "23 July 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-07-22",
    "title": "UPSC Current Affairs Quiz – 22 July 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 22 July 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "22",
    "month": "JUL",
    "monthFull": "July",
    "year": "2026",
    "isLatest": false,
    "date": "2026-07-22",
    "displayDate": "22 July 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-07-21",
    "title": "UPSC Current Affairs Quiz – 21 July 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 21 July 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "21",
    "month": "JUL",
    "monthFull": "July",
    "year": "2026",
    "isLatest": false,
    "date": "2026-07-21",
    "displayDate": "21 July 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-06-30",
    "title": "UPSC Current Affairs Quiz – 30 June 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 June 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "JUN",
    "monthFull": "June",
    "year": "2026",
    "isLatest": false,
    "date": "2026-06-30",
    "displayDate": "30 June 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-06-29",
    "title": "UPSC Current Affairs Quiz – 29 June 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 June 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "JUN",
    "monthFull": "June",
    "year": "2026",
    "isLatest": false,
    "date": "2026-06-29",
    "displayDate": "29 June 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-06-28",
    "title": "UPSC Current Affairs Quiz – 28 June 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 June 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "JUN",
    "monthFull": "June",
    "year": "2026",
    "isLatest": false,
    "date": "2026-06-28",
    "displayDate": "28 June 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-06-27",
    "title": "UPSC Current Affairs Quiz – 27 June 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 27 June 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "27",
    "month": "JUN",
    "monthFull": "June",
    "year": "2026",
    "isLatest": false,
    "date": "2026-06-27",
    "displayDate": "27 June 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-06-26",
    "title": "UPSC Current Affairs Quiz – 26 June 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 26 June 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "26",
    "month": "JUN",
    "monthFull": "June",
    "year": "2026",
    "isLatest": false,
    "date": "2026-06-26",
    "displayDate": "26 June 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-06-25",
    "title": "UPSC Current Affairs Quiz – 25 June 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 25 June 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "25",
    "month": "JUN",
    "monthFull": "June",
    "year": "2026",
    "isLatest": false,
    "date": "2026-06-25",
    "displayDate": "25 June 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-06-24",
    "title": "UPSC Current Affairs Quiz – 24 June 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 24 June 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "24",
    "month": "JUN",
    "monthFull": "June",
    "year": "2026",
    "isLatest": false,
    "date": "2026-06-24",
    "displayDate": "24 June 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-06-23",
    "title": "UPSC Current Affairs Quiz – 23 June 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 23 June 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "23",
    "month": "JUN",
    "monthFull": "June",
    "year": "2026",
    "isLatest": false,
    "date": "2026-06-23",
    "displayDate": "23 June 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-06-22",
    "title": "UPSC Current Affairs Quiz – 22 June 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 22 June 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "22",
    "month": "JUN",
    "monthFull": "June",
    "year": "2026",
    "isLatest": false,
    "date": "2026-06-22",
    "displayDate": "22 June 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-06-21",
    "title": "UPSC Current Affairs Quiz – 21 June 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 21 June 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "21",
    "month": "JUN",
    "monthFull": "June",
    "year": "2026",
    "isLatest": false,
    "date": "2026-06-21",
    "displayDate": "21 June 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-06-20",
    "title": "UPSC Current Affairs Quiz – 20 June 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 20 June 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "20",
    "month": "JUN",
    "monthFull": "June",
    "year": "2026",
    "isLatest": false,
    "date": "2026-06-20",
    "displayDate": "20 June 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-05-31",
    "title": "UPSC Current Affairs Quiz – 31 May 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 31 May 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "31",
    "month": "MAY",
    "monthFull": "May",
    "year": "2026",
    "isLatest": false,
    "date": "2026-05-31",
    "displayDate": "31 May 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-05-30",
    "title": "UPSC Current Affairs Quiz – 30 May 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 May 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "MAY",
    "monthFull": "May",
    "year": "2026",
    "isLatest": false,
    "date": "2026-05-30",
    "displayDate": "30 May 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-05-29",
    "title": "UPSC Current Affairs Quiz – 29 May 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 May 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "MAY",
    "monthFull": "May",
    "year": "2026",
    "isLatest": false,
    "date": "2026-05-29",
    "displayDate": "29 May 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-05-28",
    "title": "UPSC Current Affairs Quiz – 28 May 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 May 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "MAY",
    "monthFull": "May",
    "year": "2026",
    "isLatest": false,
    "date": "2026-05-28",
    "displayDate": "28 May 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-05-27",
    "title": "UPSC Current Affairs Quiz – 27 May 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 27 May 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "27",
    "month": "MAY",
    "monthFull": "May",
    "year": "2026",
    "isLatest": false,
    "date": "2026-05-27",
    "displayDate": "27 May 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-05-26",
    "title": "UPSC Current Affairs Quiz – 26 May 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 26 May 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "26",
    "month": "MAY",
    "monthFull": "May",
    "year": "2026",
    "isLatest": false,
    "date": "2026-05-26",
    "displayDate": "26 May 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-05-25",
    "title": "UPSC Current Affairs Quiz – 25 May 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 25 May 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "25",
    "month": "MAY",
    "monthFull": "May",
    "year": "2026",
    "isLatest": false,
    "date": "2026-05-25",
    "displayDate": "25 May 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-05-24",
    "title": "UPSC Current Affairs Quiz – 24 May 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 24 May 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "24",
    "month": "MAY",
    "monthFull": "May",
    "year": "2026",
    "isLatest": false,
    "date": "2026-05-24",
    "displayDate": "24 May 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-05-23",
    "title": "UPSC Current Affairs Quiz – 23 May 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 23 May 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "23",
    "month": "MAY",
    "monthFull": "May",
    "year": "2026",
    "isLatest": false,
    "date": "2026-05-23",
    "displayDate": "23 May 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-05-22",
    "title": "UPSC Current Affairs Quiz – 22 May 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 22 May 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "22",
    "month": "MAY",
    "monthFull": "May",
    "year": "2026",
    "isLatest": false,
    "date": "2026-05-22",
    "displayDate": "22 May 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-05-21",
    "title": "UPSC Current Affairs Quiz – 21 May 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 21 May 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "21",
    "month": "MAY",
    "monthFull": "May",
    "year": "2026",
    "isLatest": false,
    "date": "2026-05-21",
    "displayDate": "21 May 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-04-30",
    "title": "UPSC Current Affairs Quiz – 30 April 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 April 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "APR",
    "monthFull": "April",
    "year": "2026",
    "isLatest": false,
    "date": "2026-04-30",
    "displayDate": "30 April 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-04-29",
    "title": "UPSC Current Affairs Quiz – 29 April 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 April 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "APR",
    "monthFull": "April",
    "year": "2026",
    "isLatest": false,
    "date": "2026-04-29",
    "displayDate": "29 April 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-04-28",
    "title": "UPSC Current Affairs Quiz – 28 April 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 April 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "APR",
    "monthFull": "April",
    "year": "2026",
    "isLatest": false,
    "date": "2026-04-28",
    "displayDate": "28 April 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-04-27",
    "title": "UPSC Current Affairs Quiz – 27 April 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 27 April 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "27",
    "month": "APR",
    "monthFull": "April",
    "year": "2026",
    "isLatest": false,
    "date": "2026-04-27",
    "displayDate": "27 April 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-04-26",
    "title": "UPSC Current Affairs Quiz – 26 April 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 26 April 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "26",
    "month": "APR",
    "monthFull": "April",
    "year": "2026",
    "isLatest": false,
    "date": "2026-04-26",
    "displayDate": "26 April 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-04-25",
    "title": "UPSC Current Affairs Quiz – 25 April 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 25 April 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "25",
    "month": "APR",
    "monthFull": "April",
    "year": "2026",
    "isLatest": false,
    "date": "2026-04-25",
    "displayDate": "25 April 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-04-24",
    "title": "UPSC Current Affairs Quiz – 24 April 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 24 April 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "24",
    "month": "APR",
    "monthFull": "April",
    "year": "2026",
    "isLatest": false,
    "date": "2026-04-24",
    "displayDate": "24 April 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-04-23",
    "title": "UPSC Current Affairs Quiz – 23 April 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 23 April 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "23",
    "month": "APR",
    "monthFull": "April",
    "year": "2026",
    "isLatest": false,
    "date": "2026-04-23",
    "displayDate": "23 April 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-04-22",
    "title": "UPSC Current Affairs Quiz – 22 April 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 22 April 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "22",
    "month": "APR",
    "monthFull": "April",
    "year": "2026",
    "isLatest": false,
    "date": "2026-04-22",
    "displayDate": "22 April 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-04-21",
    "title": "UPSC Current Affairs Quiz – 21 April 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 21 April 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "21",
    "month": "APR",
    "monthFull": "April",
    "year": "2026",
    "isLatest": false,
    "date": "2026-04-21",
    "displayDate": "21 April 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-04-20",
    "title": "UPSC Current Affairs Quiz – 20 April 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 20 April 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "20",
    "month": "APR",
    "monthFull": "April",
    "year": "2026",
    "isLatest": false,
    "date": "2026-04-20",
    "displayDate": "20 April 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-03-31",
    "title": "UPSC Current Affairs Quiz – 31 March 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 31 March 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "31",
    "month": "MAR",
    "monthFull": "March",
    "year": "2026",
    "isLatest": false,
    "date": "2026-03-31",
    "displayDate": "31 March 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-03-30",
    "title": "UPSC Current Affairs Quiz – 30 March 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 March 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "MAR",
    "monthFull": "March",
    "year": "2026",
    "isLatest": false,
    "date": "2026-03-30",
    "displayDate": "30 March 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-03-29",
    "title": "UPSC Current Affairs Quiz – 29 March 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 March 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "MAR",
    "monthFull": "March",
    "year": "2026",
    "isLatest": false,
    "date": "2026-03-29",
    "displayDate": "29 March 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-03-28",
    "title": "UPSC Current Affairs Quiz – 28 March 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 March 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "MAR",
    "monthFull": "March",
    "year": "2026",
    "isLatest": false,
    "date": "2026-03-28",
    "displayDate": "28 March 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-03-27",
    "title": "UPSC Current Affairs Quiz – 27 March 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 27 March 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "27",
    "month": "MAR",
    "monthFull": "March",
    "year": "2026",
    "isLatest": false,
    "date": "2026-03-27",
    "displayDate": "27 March 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-03-26",
    "title": "UPSC Current Affairs Quiz – 26 March 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 26 March 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "26",
    "month": "MAR",
    "monthFull": "March",
    "year": "2026",
    "isLatest": false,
    "date": "2026-03-26",
    "displayDate": "26 March 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-03-25",
    "title": "UPSC Current Affairs Quiz – 25 March 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 25 March 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "25",
    "month": "MAR",
    "monthFull": "March",
    "year": "2026",
    "isLatest": false,
    "date": "2026-03-25",
    "displayDate": "25 March 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-03-24",
    "title": "UPSC Current Affairs Quiz – 24 March 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 24 March 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "24",
    "month": "MAR",
    "monthFull": "March",
    "year": "2026",
    "isLatest": false,
    "date": "2026-03-24",
    "displayDate": "24 March 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-03-23",
    "title": "UPSC Current Affairs Quiz – 23 March 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 23 March 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "23",
    "month": "MAR",
    "monthFull": "March",
    "year": "2026",
    "isLatest": false,
    "date": "2026-03-23",
    "displayDate": "23 March 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-03-22",
    "title": "UPSC Current Affairs Quiz – 22 March 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 22 March 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "22",
    "month": "MAR",
    "monthFull": "March",
    "year": "2026",
    "isLatest": false,
    "date": "2026-03-22",
    "displayDate": "22 March 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-03-21",
    "title": "UPSC Current Affairs Quiz – 21 March 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 21 March 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "21",
    "month": "MAR",
    "monthFull": "March",
    "year": "2026",
    "isLatest": false,
    "date": "2026-03-21",
    "displayDate": "21 March 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-02-28",
    "title": "UPSC Current Affairs Quiz – 28 February 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 February 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "FEB",
    "monthFull": "February",
    "year": "2026",
    "isLatest": false,
    "date": "2026-02-28",
    "displayDate": "28 February 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-02-27",
    "title": "UPSC Current Affairs Quiz – 27 February 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 27 February 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "27",
    "month": "FEB",
    "monthFull": "February",
    "year": "2026",
    "isLatest": false,
    "date": "2026-02-27",
    "displayDate": "27 February 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-02-26",
    "title": "UPSC Current Affairs Quiz – 26 February 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 26 February 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "26",
    "month": "FEB",
    "monthFull": "February",
    "year": "2026",
    "isLatest": false,
    "date": "2026-02-26",
    "displayDate": "26 February 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-02-25",
    "title": "UPSC Current Affairs Quiz – 25 February 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 25 February 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "25",
    "month": "FEB",
    "monthFull": "February",
    "year": "2026",
    "isLatest": false,
    "date": "2026-02-25",
    "displayDate": "25 February 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-02-24",
    "title": "UPSC Current Affairs Quiz – 24 February 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 24 February 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "24",
    "month": "FEB",
    "monthFull": "February",
    "year": "2026",
    "isLatest": false,
    "date": "2026-02-24",
    "displayDate": "24 February 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-02-23",
    "title": "UPSC Current Affairs Quiz – 23 February 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 23 February 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "23",
    "month": "FEB",
    "monthFull": "February",
    "year": "2026",
    "isLatest": false,
    "date": "2026-02-23",
    "displayDate": "23 February 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-02-22",
    "title": "UPSC Current Affairs Quiz – 22 February 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 22 February 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "22",
    "month": "FEB",
    "monthFull": "February",
    "year": "2026",
    "isLatest": false,
    "date": "2026-02-22",
    "displayDate": "22 February 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-02-21",
    "title": "UPSC Current Affairs Quiz – 21 February 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 21 February 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "21",
    "month": "FEB",
    "monthFull": "February",
    "year": "2026",
    "isLatest": false,
    "date": "2026-02-21",
    "displayDate": "21 February 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-02-20",
    "title": "UPSC Current Affairs Quiz – 20 February 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 20 February 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "20",
    "month": "FEB",
    "monthFull": "February",
    "year": "2026",
    "isLatest": false,
    "date": "2026-02-20",
    "displayDate": "20 February 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-02-19",
    "title": "UPSC Current Affairs Quiz – 19 February 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 19 February 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "19",
    "month": "FEB",
    "monthFull": "February",
    "year": "2026",
    "isLatest": false,
    "date": "2026-02-19",
    "displayDate": "19 February 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-01-31",
    "title": "UPSC Current Affairs Quiz – 31 January 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 31 January 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "31",
    "month": "JAN",
    "monthFull": "January",
    "year": "2026",
    "isLatest": false,
    "date": "2026-01-31",
    "displayDate": "31 January 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-01-30",
    "title": "UPSC Current Affairs Quiz – 30 January 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 January 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "JAN",
    "monthFull": "January",
    "year": "2026",
    "isLatest": false,
    "date": "2026-01-30",
    "displayDate": "30 January 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-01-29",
    "title": "UPSC Current Affairs Quiz – 29 January 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 January 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "JAN",
    "monthFull": "January",
    "year": "2026",
    "isLatest": false,
    "date": "2026-01-29",
    "displayDate": "29 January 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-01-28",
    "title": "UPSC Current Affairs Quiz – 28 January 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 January 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "JAN",
    "monthFull": "January",
    "year": "2026",
    "isLatest": false,
    "date": "2026-01-28",
    "displayDate": "28 January 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-01-27",
    "title": "UPSC Current Affairs Quiz – 27 January 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 27 January 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "27",
    "month": "JAN",
    "monthFull": "January",
    "year": "2026",
    "isLatest": false,
    "date": "2026-01-27",
    "displayDate": "27 January 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-01-26",
    "title": "UPSC Current Affairs Quiz – 26 January 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 26 January 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "26",
    "month": "JAN",
    "monthFull": "January",
    "year": "2026",
    "isLatest": false,
    "date": "2026-01-26",
    "displayDate": "26 January 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-01-25",
    "title": "UPSC Current Affairs Quiz – 25 January 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 25 January 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "25",
    "month": "JAN",
    "monthFull": "January",
    "year": "2026",
    "isLatest": false,
    "date": "2026-01-25",
    "displayDate": "25 January 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-01-24",
    "title": "UPSC Current Affairs Quiz – 24 January 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 24 January 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "24",
    "month": "JAN",
    "monthFull": "January",
    "year": "2026",
    "isLatest": false,
    "date": "2026-01-24",
    "displayDate": "24 January 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-01-23",
    "title": "UPSC Current Affairs Quiz – 23 January 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 23 January 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "23",
    "month": "JAN",
    "monthFull": "January",
    "year": "2026",
    "isLatest": false,
    "date": "2026-01-23",
    "displayDate": "23 January 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-01-22",
    "title": "UPSC Current Affairs Quiz – 22 January 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 22 January 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "22",
    "month": "JAN",
    "monthFull": "January",
    "year": "2026",
    "isLatest": false,
    "date": "2026-01-22",
    "displayDate": "22 January 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2026-01-21",
    "title": "UPSC Current Affairs Quiz – 21 January 2026 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 21 January 2026",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "21",
    "month": "JAN",
    "monthFull": "January",
    "year": "2026",
    "isLatest": false,
    "date": "2026-01-21",
    "displayDate": "21 January 2026",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2025-10-30",
    "title": "UPSC Current Affairs Quiz – 30 October 2025 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 October 2025",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "OCT",
    "monthFull": "October",
    "year": "2025",
    "isLatest": false,
    "date": "2025-10-30",
    "displayDate": "30 October 2025",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2025-10-29",
    "title": "UPSC Current Affairs Quiz – 29 October 2025 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 October 2025",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "OCT",
    "monthFull": "October",
    "year": "2025",
    "isLatest": false,
    "date": "2025-10-29",
    "displayDate": "29 October 2025",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2025-09-29",
    "title": "UPSC Current Affairs Quiz – 29 September 2025 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 September 2025",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "SEP",
    "monthFull": "September",
    "year": "2025",
    "isLatest": false,
    "date": "2025-09-29",
    "displayDate": "29 September 2025",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2025-09-28",
    "title": "UPSC Current Affairs Quiz – 28 September 2025 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 September 2025",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "SEP",
    "monthFull": "September",
    "year": "2025",
    "isLatest": false,
    "date": "2025-09-28",
    "displayDate": "28 September 2025",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2025-08-30",
    "title": "UPSC Current Affairs Quiz – 30 August 2025 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 August 2025",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "AUG",
    "monthFull": "August",
    "year": "2025",
    "isLatest": false,
    "date": "2025-08-30",
    "displayDate": "30 August 2025",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2024-10-30",
    "title": "UPSC Current Affairs Quiz – 30 October 2024 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 October 2024",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "OCT",
    "monthFull": "October",
    "year": "2024",
    "isLatest": false,
    "date": "2024-10-30",
    "displayDate": "30 October 2024",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2024-10-29",
    "title": "UPSC Current Affairs Quiz – 29 October 2024 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 October 2024",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "OCT",
    "monthFull": "October",
    "year": "2024",
    "isLatest": false,
    "date": "2024-10-29",
    "displayDate": "29 October 2024",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2024-09-29",
    "title": "UPSC Current Affairs Quiz – 29 September 2024 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 29 September 2024",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "29",
    "month": "SEP",
    "monthFull": "September",
    "year": "2024",
    "isLatest": false,
    "date": "2024-09-29",
    "displayDate": "29 September 2024",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2024-09-28",
    "title": "UPSC Current Affairs Quiz – 28 September 2024 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 28 September 2024",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "28",
    "month": "SEP",
    "monthFull": "September",
    "year": "2024",
    "isLatest": false,
    "date": "2024-09-28",
    "displayDate": "28 September 2024",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  },
  {
    "id": "quiz-2024-08-30",
    "title": "UPSC Current Affairs Quiz – 30 August 2024 | Daily Prelims Quiz",
    "shortTitle": "UPSC Current Affairs Quiz : 30 August 2024",
    "category": "CURRENT AFFAIRS QUIZ",
    "day": "30",
    "month": "AUG",
    "monthFull": "August",
    "year": "2024",
    "isLatest": false,
    "date": "2024-08-30",
    "displayDate": "30 August 2024",
    "totalQuestions": 10,
    "timeMinutes": 16,
    "marksPerCorrect": 2,
    "negativeMarks": 0.66,
    "description": "The Current Affairs Quiz is a daily quiz based on the DAILY CURRENT AFFAIRS AND PIB SUMMARY from the previous day, as posted on our website. It covers all relevant news sources and is designed to test your knowledge of current events. Solving these questions will help you retain both concepts and facts relevant to the UPSC IAS civil services exam.",
    "questions": [
      {
        "qId": 1,
        "topic": "Polity & Parliamentary Committees",
        "question": "Which of the following Parliamentary Committees is headed by the Speaker of the Lok Sabha as the ex-officio Chairman?\n1. Business Advisory Committee\n2. Committee on Petitions\n3. Rules Committee\n4. General Purposes Committee\nSelect the correct answer using the code given below:",
        "options": [
          "1, 2 and 3 only",
          "1, 3 and 4 only",
          "2, 3 and 4 only",
          "1, 2, 3 and 4"
        ],
        "correctAnswer": 1,
        "explanation": "The Speaker of Lok Sabha is the ex-officio Chairman of the Business Advisory Committee, Rules Committee, and General Purposes Committee."
      },
      {
        "qId": 2,
        "topic": "Science & Technology - Quantum Computing",
        "question": "What is 'Quantum Supremacy', frequently discussed in modern technological breakthroughs?",
        "options": [
          "A state where quantum computers completely replace classical binary computing in commercial servers.",
          "The ability of a quantum device to solve a problem that is practically impossible for any classical supercomputer within a reasonable timeframe.",
          "Achieving room-temperature superconductivity in quantum chips.",
          "The military superiority gained through quantum-encrypted satellite telecommunication."
        ],
        "correctAnswer": 1,
        "explanation": "Quantum supremacy refers to the demonstration of a programmable quantum device solving a computational problem that no classical computer could feasibly solve in reasonable time."
      },
      {
        "qId": 3,
        "topic": "Environment - Critical Minerals",
        "question": "Which of the following international alliances has India joined to secure global supply chains for critical energy transition minerals?",
        "options": [
          "Mineral Security Partnership (MSP)",
          "International Critical Minerals Accord (ICMA)",
          "Global Battery Alliance (GBA)",
          "International Rare Earths Cartel (IREC)"
        ],
        "correctAnswer": 0,
        "explanation": "India was inducted as the 14th member of the US-led Mineral Security Partnership (MSP) to secure critical mineral supply chains."
      },
      {
        "qId": 4,
        "topic": "Economy - Fiscal Federalism",
        "question": "According to Article 280 of the Constitution, the Finance Commission recommends the distribution of the net proceeds of taxes between the Union and the States. Which among the following is NOT part of the divisible pool of central taxes?",
        "options": [
          "Corporation Tax",
          "Central GST (CGST)",
          "Cesses and Surcharges levied under Article 271",
          "Integrated GST (IGST) attributable to the Centre"
        ],
        "correctAnswer": 2,
        "explanation": "Cesses and surcharges levied by the Centre under Article 271 do NOT form part of the divisible pool and are retained 100% by the Central Government."
      },
      {
        "qId": 5,
        "topic": "Geography - Straits & Chokepoints",
        "question": "The Bab-el-Mandeb Strait connects which of the following water bodies?",
        "options": [
          "Persian Gulf and Gulf of Oman",
          "Red Sea and Gulf of Aden",
          "Mediterranean Sea and Red Sea",
          "Black Sea and Sea of Marmara"
        ],
        "correctAnswer": 1,
        "explanation": "The Bab-el-Mandeb Strait connects the Red Sea to the Gulf of Aden, bounded by Yemen and Djibouti."
      },
      {
        "qId": 6,
        "topic": "Energy - National Green Hydrogen Mission",
        "question": "Under the National Green Hydrogen Mission, what is India's targeted annual green hydrogen production capacity by 2030?",
        "options": [
          "At least 5 Million Metric Tonnes (MMT) per annum",
          "1 MMT per annum",
          "15 MMT per annum",
          "20 MMT per annum"
        ],
        "correctAnswer": 0,
        "explanation": "The National Green Hydrogen Mission targets at least 5 Million Metric Tonnes (MMT) per annum production by 2030."
      },
      {
        "qId": 7,
        "topic": "Environment - Wildlife Protection Act",
        "question": "With reference to the Wildlife (Protection) Amendment Act 2022, consider the following statements:\n1. It reduced the number of Schedules from six to four.\n2. Schedule IV is dedicated to specimens of flora and fauna listed under CITES.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. Schedules were reduced from six to four, with Schedule IV covering CITES specimens."
      },
      {
        "qId": 8,
        "topic": "International Trade - CBAM",
        "question": "The 'Carbon Border Adjustment Mechanism' (CBAM), recently in the news, is a regulation proposed and adopted by:",
        "options": [
          "European Union",
          "United States",
          "World Trade Organization",
          "OECD"
        ],
        "correctAnswer": 0,
        "explanation": "CBAM was enacted by the European Union to place a carbon price on imports of carbon-intensive products into the EU."
      },
      {
        "qId": 9,
        "topic": "Economy - Digital Markets Regulation",
        "question": "The proposed 'Digital Competition Bill' in India introduces 'ex-ante' regulation targeting which entities?",
        "options": [
          "Systemically Significant Digital Enterprises (SSDEs)",
          "Small and Medium Tech Startups",
          "Public Sector Telecom Companies",
          "Cybersecurity Certification Authorities"
        ],
        "correctAnswer": 0,
        "explanation": "The draft Digital Competition Bill targets Systemically Significant Digital Enterprises (SSDEs) to prevent anti-competitive conduct."
      },
      {
        "qId": 10,
        "topic": "Space Technology - Launch Vehicles",
        "question": "Consider the following statements regarding ISRO's Polar Satellite Launch Vehicle (PSLV):\n1. It is a four-stage launch vehicle using alternating solid and liquid propulsion systems.\n2. The second stage uses the Vikas engine powered by hypergolic liquid propellants.\nWhich of the statements given above is/are correct?",
        "options": [
          "1 only",
          "2 only",
          "Both 1 and 2",
          "Neither 1 nor 2"
        ],
        "correctAnswer": 2,
        "explanation": "Both statements are correct. PSLV uses 4 stages: 1st solid, 2nd liquid (Vikas engine), 3rd solid, 4th liquid."
      }
    ]
  }
];

export const jnanaDeepamMains = [
  // ----------------- 31 OCTOBER 2026 (INSIGHTS MINI SECURE) -----------------
  {
    id: "sec-20261031-q1",
    date: "2026-10-31",
    dateDisplay: "31 October 2026",
    edition: "Insights Mini SECURE",
    qNumber: "Q1",
    paper: "GS Paper 1",
    subject: "Physical Geography",
    topic: "Important Geophysical phenomena such as earthquakes, Tsunami, Volcanic activity, cyclone, ocean-atmosphere interactions.",
    marks: 10,
    words: 150,
    suggestedTime: "7 Minutes",
    difficulty: "Medium",
    directive: "Explain this feedback mechanism",
    reference: "The Hindu / NOAA & IMD Pacific Ocean Observations",
    whyTheQuestion:
      "Recent anomalous warming across the equatorial eastern Pacific Ocean in late 2026 has reignited meteorological discussions on the Bjerknes feedback loop and its cascading effects on the Asian summer monsoon.",
    keyDemand:
      "Explain the bidirectional coupled ocean-atmosphere positive feedback loop (Bjerknes Feedback) where weakened trade winds trigger sea surface warming, which in turn further diminishes the zonal pressure gradient and relaxes the trade winds.",
    question:
      "“The weakening of trade winds is both a cause and a consequence of El Niño development.” Explain this feedback mechanism. (10 Marks, 150 Words)",
    framework: {
      introduction:
        "Define the El Niño-Southern Oscillation (ENSO) as a coupled ocean-atmosphere phenomenon in the equatorial Pacific, driven fundamentally by the positive Bjerknes feedback loop.",
      body: [
        "Trade Winds as a Cause (Initiation): Under normal Walker circulation, strong easterly trade winds pile warm water in the Western Pacific (Warm Pool) and induce cold upwelling in the East (Peru coast). When westerly wind bursts occur, trade winds weaken, reducing upwelling and allowing warm water to slosh eastward as downwelling Kelvin waves.",
        "Trade Winds as a Consequence (Amplification): As warm surface water shifts to central and eastern Pacific, the east-west sea surface temperature (SST) gradient flattens. This diminishes the atmospheric Walker cell pressure gradient, which further suppresses the easterly trade winds, locking the ocean-atmosphere system into an El Niño state.",
        "Equilibrium Termination: Negative delayed feedback (Rossby wave reflection at western boundary) eventually shoals the thermocline and terminates the cycle.",
      ],
      conclusion:
        "Conclude that understanding this self-reinforcing coupling is vital for dynamic coupled climate models (like CFSv2 and Monsoon Mission models) to accurately forecast global teleconnections, including droughts across the Indian subcontinent.",
    },
    modelSynopsis:
      "The El Niño phenomenon exemplifies the intricate ocean-atmosphere coupling known as the Bjerknes feedback mechanism. Under standard conditions, easterly trade winds drive surface water westward, sustaining the Pacific Warm Pool and inducing nutrient-rich cold upwelling off the Peruvian coast, creating a steep zonal temperature and pressure gradient.\n\n1. How Weakening Acts as a Cause:\nA transient meteorological perturbation (such as Madden-Julian Oscillation or westerly wind bursts) relaxes the easterly trade winds. This reduction in wind stress arrests the mechanical piling of water in the west, triggering downwelling oceanic Kelvin waves that travel eastwards, deepening the thermocline and warming the central and eastern Pacific.\n\n2. How Weakening is a Consequence:\nAs the eastern Pacific warms, the east-west temperature contrast diminishes. Because surface atmospheric pressure is dictated by underlying sea surface temperatures, the lower tropospheric pressure gradient collapses. Consequently, the atmospheric Walker circulation weakens, leading to a further slacking of easterly trade winds.\n\nThus, trade wind relaxation and sea surface warming continuously reinforce one another until slow-moving off-equatorial Rossby waves reflect from the western boundary to terminate the event.",
    evaluationCriteria: [
      "Explicitly mentioned the Bjerknes feedback mechanism",
      "Explained both causal direction (winds -> ocean) and consequential direction (ocean -> winds)",
      "Used geographical terms like Walker Circulation, Thermocline, Kelvin Waves, SST gradient",
      "Diagrammatic mental representation or schema of the Pacific basin referenced",
    ],
  },
  {
    id: "sec-20261031-q2",
    date: "2026-10-31",
    dateDisplay: "31 October 2026",
    edition: "Insights Mini SECURE",
    qNumber: "Q2",
    paper: "GS Paper 1",
    subject: "Indian Society",
    topic: "Role of women and women’s organization, urbanization, social empowerment and poverty alleviation.",
    marks: 15,
    words: 250,
    suggestedTime: "11 Minutes",
    difficulty: "Analytical",
    directive: "Discuss",
    reference: "The Indian Express / World Bank & ILO Urban Mobility Report",
    whyTheQuestion:
      "Urban mobility surveys highlight that Indian women face disproportionate transit poverty, safety deficits, and spatial segregation, directly impacting Female Labor Force Participation (FLFPR) which remains around 37%.",
    keyDemand:
      "Discuss how women's mobility transcends simple transportation infrastructure to become a structural barometer of gender equality, bodily autonomy, economic productivity, and socio-cultural agency.",
    question:
      "“Women’s mobility is not merely a matter of physical movement but a reflection of their freedom to participate in social and economic life.” Discuss. (15 Marks, 250 Words)",
    framework: {
      introduction:
        "Frame mobility as a capability (Amartya Sen's Capability Approach), arguing that freedom of spatial transit is intrinsically linked to substantive citizenship, agency, and economic emancipation.",
      body: [
        "Mobility as Economic Agency: Trip chaining behavior (combining care work, schooling, groceries, employment); high transit costs push women into low-productivity local informal jobs; affordable and secure transport directly correlates with higher Female Labor Force Participation (FLFPR).",
        "Mobility as Social & Cultural Freedom: Overcoming patriarchal spatial surveillance and moral policing; access to higher education, vocational training, leisure, and healthcare centers; public spaces as sites of democratic equality.",
        "Structural Impediments: Inadequate street lighting, absent last-mile connectivity, sexual harassment in transit, hostile pedestrian design, and unaffordable fare structures.",
        "Progressive Interventions: Fare-free bus schemes (e.g., Shakti in Karnataka, Mahalakshmi in Telangana), gender-responsive urban planning, night-patrols, pink transport, and participatory safety audits.",
      ],
      conclusion:
        "Reiterate that gender-sensitive public transit transforms cities from patriarchal fortresses into inclusive spaces of empowerment, realizing SDG 5 (Gender Equality) and SDG 11 (Sustainable Cities).",
    },
    modelSynopsis:
      "Physical mobility is frequently misconstrued as an engineering or infrastructural index. For women, however, spatial mobility functions as a tangible proxy for bodily autonomy, socioeconomic freedom, and democratic participation in the public sphere.\n\n1. Economic Dimensions of Mobility:\n- Labor Market Inclusion: Women's commuting patterns are fundamentally distinct; they practice 'trip chaining'—combining employment with caregiving duties. High transport costs or perceived safety risks force women into low-paying, localized informal jobs.\n- Education and Skilling: Restricting transit radius limits female enrollment in premier collegiate and vocational institutions, perpetuating the skill gap.\n\n2. Sociocultural Dimensions of Mobility:\n- Reclaiming Public Space: In many traditional settings, a woman’s presence in public spaces is conditioned on 'purposefulness', subjecting her to societal surveillance and honor codes. Unencumbered mobility challenges patriarchal territoriality.\n- Political and Civic Voice: Safe mobility allows women to attend gram sabhas, community mobilizations, and union meetings.\n\n3. Overcoming Transit Barriers:\nAddressing this requires holistic urban design: improving last-mile transit, instituting universal zero-fare policies for women (as demonstrated in southern states), illuminated walking corridors, and bystander intervention programs.",
    evaluationCriteria: [
      "Covered both economic (jobs, skills) and social (agency, safety, public space) dimensions",
      "Mentioned concept of 'trip-chaining' and spatial patriarchy",
      "Cited state initiatives (e.g., zero-fare transit schemes, safety audits)",
      "Linked to constitutional freedoms (Art 19(1)(d), Art 21) or SDGs",
    ],
  },
  {
    id: "sec-20261031-q3",
    date: "2026-10-31",
    dateDisplay: "31 October 2026",
    edition: "Insights Mini SECURE",
    qNumber: "Q3",
    paper: "GS Paper 2",
    subject: "Polity & Constitution",
    topic: "Directive Principles of State Policy, welfare state architecture, addressing emerging socio-economic inequalities.",
    marks: 15,
    words: 250,
    suggestedTime: "11 Minutes",
    difficulty: "Moderate",
    directive: "Examine, Assess, and Suggest",
    reference: "The Hindu / Supreme Court Jurisprudence on Articles 39(b) & 39(c)",
    whyTheQuestion:
      "Mounting income and wealth disparities (highlighted by the World Inequality Lab) alongside technological automation disruptions have reignited constitutional debates over the non-justiciable socialist charter of Part IV.",
    keyDemand:
      "A three-part inquiry: (1) Examine the role of DPSPs in historic post-independence nation building; (2) Assess their relevance in counteracting contemporary inequalities (wealth concentration, gig economy, digital divide); (3) Suggest actionable constitutional and policy measures to strengthen their enforceability.",
    question:
      "Examine the role of Directive Principles in shaping India’s development model since Independence. Assess their relevance in addressing emerging socio-economic inequalities. Suggest measures to strengthen their implementation. (15 Marks, 250 Words)",
    framework: {
      introduction:
        "Introduce DPSPs (Part IV, Articles 36-51) as the constitutional blueprint of an egalitarian welfare state, described by Granville Austin as the 'conscience of the Constitution'.",
      body: [
        "Historical Role in Post-Independence Architecture: Land ceiling and zamindari abolition (Art 39b/c), Panchayati Raj through 73rd/74th Amendments (Art 40), Right to Education Act (Art 45/21A), National Rural Employment Guarantee (Art 41), Maternity Benefit Act (Art 42), and legal aid (Art 39A).",
        "Relevance in Addressing Emerging Inequalities: Mitigating hyper-concentration of wealth (Art 39c) amidst billionaire booms; social security for gig and platform workers (Art 43 living wage); ethical regulation of AI and automated displacement; ecological justice (Art 48A) protecting vulnerable forest dwellers.",
        "Measures to Strengthen Implementation: Mandatory Socio-Economic Impact Assessments for all major fiscal bills; programmatic baseline targets linked to DPSP goals in NITI Aayog's SDG India Index; establishing non-adversarial Parliamentary Committees on Directive Principles.",
      ],
      conclusion:
        "Synthesize with the Minerva Mills doctrine: the Indian Constitution is founded on the bedrock of the balance between Fundamental Rights and Directive Principles. Achieving Viksit Bharat 2047 requires infusing non-justiciable moral imperatives with programmatic statutory backing.",
    },
    modelSynopsis:
      "Part IV of the Constitution embodies Dr. B.R. Ambedkar’s vision of establishing 'economic democracy' alongside political democracy. Though non-justiciable under Article 37, DPSPs have operated as the North Star for state policymaking.\n\n1. Shaping India's Development Model:\n- Agrarian Justice: Zamindari abolition, tenancy reforms, and nationalization of key industries drew legitimacy from Article 39(b) and (c).\n- Democratic Decentralization: Article 40 materialized into the historic 73rd and 74th Constitutional Amendment Acts.\n- Welfare Safety Nets: Flagship enactments like MGNREGA (Right to Work under Art 41), National Food Security Act, and the Right to Education Act (derived from Art 45) represent the progressive statutory codification of DPSPs.\n\n2. Relevance in Mitigating Contemporary Inequalities:\n- Wealth Concentration: With top 1% commanding over 40% of national wealth, Article 39(c) remains profoundly relevant for progressive taxation and inheritance policies.\n- Changing World of Work: Platform gig workers and contract laborers demand minimum living wages and social security under Articles 42 and 43.\n- Digital & Environmental Divides: Articles 48A and 39A guide digital inclusion, affordable green transition, and legal empowerment for marginalized communities.\n\n3. Roadmap for Strengthening:\n- Institutional Accountability: Establish a Standing Parliamentary Committee on Directive Principles to audit legislation against Part IV goals.\n- Budgetary Earmarking: Adopt DPSP-indexed outcome budgeting across Union and State budgets.",
    evaluationCriteria: [
      "Addressed all 3 sub-parts: historical role, modern relevance, measures",
      "Cited key articles: Art 37, 39(b)(c), 40, 41, 42, 43, 48A",
      "Referenced Supreme Court landmark doctrines (Minerva Mills, Kesavananda Bharati)",
      "Balanced analysis of non-justiciability vs statutory codification",
    ],
  },
  {
    id: "sec-20261031-q4",
    date: "2026-10-31",
    dateDisplay: "31 October 2026",
    edition: "Insights Mini SECURE",
    qNumber: "Q4",
    paper: "GS Paper 2",
    subject: "Constitutional Bodies",
    topic: "Structure, functioning, conduct of business, and comparative constitutional positions of the President and Vice-President.",
    marks: 10,
    words: 150,
    suggestedTime: "7 Minutes",
    difficulty: "Moderate",
    directive: "Bring out the significance",
    reference: "Indian Constitutional Law / Sansad TV Debates",
    whyTheQuestion:
      "Recent discussions on the dual functional identity of the Vice-President as presiding officer of the Upper House and contingency Head of State highlight subtle constitutional balances.",
    keyDemand:
      "Identify the constitutional differences between the President and Vice-President regarding election, removal, primary role, and emergency duties; explain their significance in the functioning of the Union Executive.",
    question:
      "How does the constitutional position of the Vice-President differ from that of the President of India? Bring out the significance of these differences in the functioning of the Union executive. (10 Marks, 150 Words)",
    framework: {
      introduction:
        "Briefly contrast the constitutional standings: The President is the formal Head of State (Article 52/53), while the Vice-President (Article 63) holds the second-highest constitutional office with a dual role as ex-officio Chairman of Rajya Sabha (Article 64).",
      body: [
        "Core Constitutional Differences: Electoral College (President includes elected MLAs of States and UTs; VP only includes MPs of both Houses); Removal process (Impeachment under Art 61 for 'violation of Constitution' vs Council of States resolution agreed by Lok Sabha under Art 67b); Primary Function (President acts on CoM advice as executive head; VP primarily acts as legislative presiding officer).",
        "Significance for Executive Functioning: Institutional Continuity (Seamless interim presidency under Art 65 without executive paralysis during sudden vacancy); Bicameral Equilibrium (VP bridges executive and legislative branches, presiding over the House of Elders to maintain federal deliberation).",
      ],
      conclusion:
        "The Vice-Presidential design reflects functional thrift: preserving high-level constitutional succession while optimizing legislative impartiality in the Upper House.",
    },
    modelSynopsis:
      "The Constitution of India creates an asymmetric yet complementary architecture for the top two constitutional functionaries.\n\n1. Key Constitutional Differences:\n- Electoral Base: The President's electoral college encompasses elected members of Parliament and State Legislative Assemblies (reflecting federal representation), whereas the Vice-President is elected solely by members of both Houses of Parliament.\n- Primary Mandate: The President is the de jure executive head in whom Union executive power is vested (Art 53). Conversely, the Vice-President draws no salary as VP; his primary statutory task is acting as ex-officio Chairman of the Council of States (Art 64).\n- Removal Mechanism: The President undergoes rigorous impeachment for 'violation of the Constitution' requiring a 2/3rd majority of total membership in both Houses (Art 61). The Vice-President can be removed by an effective majority in Rajya Sabha consented to by simple majority in Lok Sabha.\n\n2. Significance for the Union Executive:\n- Guarantees unbroken continuity: Article 65 ensures the headship of state never lapses due to death, resignation, or removal.\n- Preserves executive-legislative harmony by placing an impartial elder statesman at the helm of the Upper House.",
    evaluationCriteria: [
      "Accurate constitutional articles (Art 52-65, 61, 64, 67)",
      "Clear differentiation in Electoral College and Removal procedures",
      "Highlighted the dual role (Chairman of Rajya Sabha vs Acting President)",
      "Explained the executive significance (institutional continuity)",
    ],
  },
  {
    id: "sec-20261031-q5",
    date: "2026-10-31",
    dateDisplay: "31 October 2026",
    edition: "Insights Mini SECURE",
    qNumber: "Q5",
    paper: "GS Paper 2",
    subject: "Judiciary & Social Justice",
    topic: "Structure, organization and functioning of the Judiciary, Gram Nyayalayas Act 2008, alternative dispute resolution.",
    marks: 10,
    words: 150,
    suggestedTime: "7 Minutes",
    difficulty: "Medium",
    directive: "Bring out and What factors have constrained",
    reference: "Law Commission of India Reports / Department of Justice",
    whyTheQuestion:
      "With over 4.5 crore pending cases and acute rural litigation backlog, the under-utilization of Gram Nyayalayas established under the 2008 Act has invited judicial scrutiny by the Supreme Court.",
    keyDemand:
      "Highlight the intended significance of Gram Nyayalayas in rural dispute resolution (Article 39A, door-step justice) and identify the structural, financial, and institutional bottlenecks constraining their operation.",
    question:
      "Bring out the significance of Gram Nyayalayas in improving access to justice in rural India. What factors have constrained their effective functioning? (10 Marks, 150 Words)",
    framework: {
      introduction:
        "Define Gram Nyayalayas as statutory mobile village courts established under the Gram Nyayalayas Act, 2008, enacted to fulfill the constitutional mandate of Article 39A (Free Legal Aid and Equal Justice).",
      body: [
        "Significance for Rural Justice: Door-step mobile adjudication reducing travel costs and wage loss; summary procedures guided by natural justice principles rather than rigid Indian Evidence Act; institutionalization of conciliation and mediation; empowerment of marginalized rural poor and women.",
        "Constraints in Effective Functioning: Tardy notification by State Governments (less than 30% of targeted 5,000+ courts notified); dual-cadre ambiguity (Nyayadhikaris drawn from regular Judicial Magistrate First Class facing transfer apathy); infrastructural deficits (lack of dedicated mobile vans and rural courtrooms); resistance from local Bar Associations; parallel jurisdiction confusion with traditional Panchayats.",
      ],
      conclusion:
        "Conclude with Law Commission recommendations: dedicated central funding, mandatory notification deadlines, and digital integration under the e-Courts mission to realize grassroots justice.",
    },
    modelSynopsis:
      "Gram Nyayalayas were conceived under the Gram Nyayalayas Act, 2008, as mobile grassroots tribunals aimed at delivering affordable, expeditious justice at the doorstep of the rural citizenry, directly furthering Article 39A.\n\n1. Significance:\n- Reduces Disproportionate Burden: Eliminates prohibitive litigation costs, intermediary exploitation, and loss of daily agricultural wages for rural litigants.\n- Procedural Flexibility: Empowered to adopt summary trial procedures and conciliation without being constrained by the rigidities of the Code of Civil Procedure or the Indian Evidence Act.\n- Mobile Outreach: Periodic camp courts in interior villages bridge the geographical chasm between rural habitations and sub-divisional courts.\n\n2. Key Constraints:\n- Lukewarm State Adoption: Only ~480 courts have been notified against an estimated national requirement exceeding 5,000.\n- Infrastructure Deficits: Scarcity of dedicated vehicles, basic ICT equipment, and administrative staff.\n- Staffing & Cadre Reluctance: Judicial officers view posting as Nyayadhikaris as punitive or non-lucrative.\n- Bar Resistance: Local lawyers often oppose informal conciliation proceedings fearing diminution of fee-based practice.",
    evaluationCriteria: [
      "Mentioned Gram Nyayalayas Act, 2008 and Article 39A",
      "Explained doorstep mobile justice & summary conciliation",
      "Detailed bottlenecks: state reluctance, infrastructure, cadre issues, bar resistance",
      "Offered crisp way forward (dedicated funding, e-court linkage)",
    ],
  },
  {
    id: "sec-20261031-q6",
    date: "2026-10-31",
    dateDisplay: "31 October 2026",
    edition: "Insights Mini SECURE",
    qNumber: "Q6",
    paper: "GS Paper 3",
    subject: "Indian Economy & Public Finance",
    topic: "Indian Economy and issues relating to planning, mobilization of resources, growth, development and taxation reforms.",
    marks: 15,
    words: 250,
    suggestedTime: "11 Minutes",
    difficulty: "Analytical",
    directive: "Explain, Evaluate, and Suggest",
    reference: "Union Budgetary Documents / Economic Survey",
    whyTheQuestion:
      "Recent overhaul and streamlining of Long-Term Capital Gains (LTCG) and Short-Term Capital Gains (STCG) rates across asset classes (equities, real estate, gold, unlisted securities) has opened debates on tax neutrality versus progressive equity.",
    keyDemand:
      "Analyze the economic rationale for rationalizing capital gains tax (eliminating arbitrage, simplification, broadening tax base); evaluate the trade-offs (market volatility, impact on middle-class savings, wealth distribution); suggest a balanced taxation roadmap.",
    question:
      "“Capital gains taxation presents a policy dilemma between promoting investment and ensuring equity in the tax system.” Explain the economic arguments for rationalising capital gains taxation in India. Evaluate the associated fiscal and distributional challenges. Also suggest measures for a balanced tax framework. (15 Marks, 250 Words)",
    framework: {
      introduction:
        "Define capital gains taxation and contextualize the policy tension between economic efficiency (capital formation, investment liquidity) and vertical equity (preventing unearned capital income from being taxed lighter than sweat labor).",
      body: [
        "Economic Arguments for Rationalization: Eliminating distortionary tax arbitrage across asset classes (equities vs real estate vs debt); reducing compliance complexity arising from disparate holding periods; anti-tax evasion (curbing sham holding transactions); aligning Indian rates with emerging market peers.",
        "Fiscal and Distributional Challenges: Impact on equity culture and retail investor participation; real estate inflation if indexation benefits are removed; wealth inequality exacerbation (top quintile captures bulk of capital gains); risk of capital flight and round-tripping.",
        "Balanced Measures for Policy Framework: Grandfathering safeguards for middle-class home buyers; indexed exemption thresholds (raising the ₹1.25L annual basic exemption in step with inflation); progressive tiering of capital gains for ultra-HNIs; uniform holding period definitions across financial assets.",
      ],
      conclusion:
        "Conclude that tax policy must balance capital accumulation for infrastructure and manufacturing with the constitutional mandate of Article 39(c) to avoid wealth concentration.",
    },
    modelSynopsis:
      "Capital gains taxation occupies the fault line between capital accumulation and redistributive justice. In developing economies like India, taxing capital requires navigating the fine balance between incentivizing risk-taking and ensuring that passive asset appreciation does not enjoy preferential immunity over hard-earned labor income.\n\n1. Economic Rationale for Rationalization:\n- Dismantling Tax Arbitrage: Prior to rationalization, India suffered from an intricate maze of holding periods (12, 24, 36 months) and rates varying widely between listed equities, debt mutual funds, and real estate, incentivizing artificial asset routing.\n- Broadening Tax Base: High-income earners routinely convert ordinary corporate revenue into capital gains to exploit concessionary tax brackets; standardized rates curb this avoidance.\n- Simplification & Certainty: A unified framework reduces astronomical tax litigation in appellate tribunals.\n\n2. Fiscal and Distributional Complexities:\n- Retail Sentiment: Over 10 crore demat account holders rely on equity returns to beat inflation; abrupt increases in STCG/LTCG risk cooling domestic capital formation.\n- Real Estate & Indexation Dilemma: Withdrawing inflation indexation without adequate rate reductions can penalize long-term homeowners holding family assets for decades.\n\n3. Balanced Policy Measures:\n- Progressive Surcharge Tiering: Maintain modest entry rates for retail investors while applying progressive surcharges on super-gains (>₹5 Crore).\n- Dynamic Inflation-Indexed Exemptions: Annually calibrate basic capital exemption limits.",
    evaluationCriteria: [
      "Structured into clear economic rationale, fiscal challenges, and remedies",
      "Contrasted capital income vs labor income taxation",
      "Discussed indexation, holding periods, and equity culture",
      "Practical policy suggestions aligned with macroeconomic growth",
    ],
  },
  {
    id: "sec-20261031-q7",
    date: "2026-10-31",
    dateDisplay: "31 October 2026",
    edition: "Insights Mini SECURE",
    qNumber: "Q7",
    paper: "GS Paper 3",
    subject: "Industrial Policy & Technology",
    topic: "Changes in industrial policy and their effects on industrial growth, electronics manufacturing, PLI scheme, global value chains.",
    marks: 10,
    words: 150,
    suggestedTime: "7 Minutes",
    difficulty: "Medium",
    directive: "Discuss",
    reference: "The Hindu Business Line / Ministry of Electronics & Information Technology (MeitY)",
    whyTheQuestion:
      "While smartphone exports from India crossed $15 billion under the Production Linked Incentive (PLI) scheme, domestic value addition remains modest at 15-20%, with core sub-assemblies and semiconductors still heavily imported.",
    keyDemand:
      "Discuss why assembly-led manufacturing ('screwing and packaging') represents a brittle growth model, and why India must transition towards deep domestic value addition (component ecosystems, design, packaging, and R&D).",
    question:
      "“India’s electronics manufacturing success must increasingly be measured by domestic value creation rather than the volume of finished products assembled.” Discuss. (10 Marks, 150 Words)",
    framework: {
      introduction:
        "Acknowledge India's phenomenal leap to becoming the world's second-largest mobile phone manufacturer, but highlight the qualitative dilemma: volume expansion vs depth of domestic value addition (DVA).",
      body: [
        "Limitations of Pure Assembly Models: 'Screwdriver operations' capture only 10-18% of product value (mostly labor and final casing); critical components (chips, sensors, camera modules, display glass) remain imported, creating huge trade deficit vulnerability.",
        "Imperatives for Domestic Value Creation: Enhances economic multiplier effects and deep MSME linkages; insulates against geopolitical supply-chain blockades; creates high-skill engineering and design employment beyond basic assembly line shopfloors.",
        "Strategic Interventions: Expanding SPECS (Scheme for Promotion of Manufacturing of Electronic Components and Semiconductors); India Semiconductor Mission (fab and ATMP/OSAT units); fostering domestic intellectual property (Design Linked Incentive - DLI).",
      ],
      conclusion:
        "Conclude that shifting focus from 'Assembled in India' to 'Designed and Innovated in India' is paramount for achieving the $300 billion electronics vision and true strategic autonomy.",
    },
    modelSynopsis:
      "India's trajectory under the Electronics PLI scheme has generated impressive headline figures, turning the country into a net exporter of finished smartphones. However, celebratory volume metrics obscure an underlying vulnerability: low domestic value addition (DVA), presently stagnating between 15% to 22%.\n\n1. The Problem with Pure Assembly:\n- Shallow Capture: The lion’s share of electronics margins (over 70%) resides in upstream component fabrication (integrated circuits, display panels, camera optics) and downstream intellectual property/software design.\n- High Import Dependency: Massive assembly outputs paradoxically drive surging imports of intermediate electronic parts, primarily from East Asia.\n\n2. The Strategic Imperative of Value Creation:\n- Resilience & Supply Security: Shielding the economy from weaponized supply chains.\n- Industrial Deepening: Fostering domestic tier-2 and tier-3 component suppliers and MSME toolmakers.\n\n3. The Path Ahead:\nCapital subsidies must transition toward component manufacturing (SPECS 2.0), semiconductor packaging (OSAT units), and chip-design IP incentives (DLI scheme).",
    evaluationCriteria: [
      "Distinguished between assembly volume and domestic value addition (DVA)",
      "Highlighted the smile curve of manufacturing (where value lies)",
      "Mentioned relevant policies: PLI, SPECS, ISM, DLI",
      "Offered crisp, forward-looking industrial roadmap",
    ],
  },
  {
    id: "sec-20261031-q8",
    date: "2026-10-31",
    dateDisplay: "31 October 2026",
    edition: "Insights Mini SECURE",
    qNumber: "Q8",
    paper: "GS Paper 3",
    subject: "Macroeconomics & Inclusive Growth",
    topic: "Inclusive growth and issues arising from it, wage share, consumption demand, and private capital expenditure.",
    marks: 10,
    words: 150,
    suggestedTime: "7 Minutes",
    difficulty: "Analytical",
    directive: "Explain this paradox with reference to consumption and investment demand",
    reference: "RBI Bulletin / ILO Global Wage Report",
    whyTheQuestion:
      "Recent economic data indicates robust corporate balance sheets and profitability alongside sluggish rural consumption and sluggish private sector capex, underscoring the macroeconomic wage-share paradox.",
    keyDemand:
      "Explain the Keynesian / Kaleckian paradox where individual firms compressing wages to protect profits collectively depress aggregate household consumption demand, leading to excess capacity and suppressing private investment.",
    question:
      "“A declining share of wages in national income may undermine the very economic growth that firms seek to sustain through cost reduction.” Explain this paradox with reference to consumption and investment demand. (10 Marks, 150 Words)",
    framework: {
      introduction:
        "Define the Wage-Share Paradox (rooted in the 'fallacy of composition'): what is micro-economically rational for a single firm (cost cutting) becomes macro-economically disastrous for the aggregate economy.",
      body: [
        "Impact on Consumption Demand: Wage earners have a significantly higher Marginal Propensity to Consume (MPC) than capital owners. When wage share contracts, aggregate household disposable income shrinks, precipitating demand stagnation in FMCG, mass durables, and entry-level automobiles.",
        "Impact on Investment Demand: Private capital expenditure (capex) is driven by capacity utilization and anticipated future consumer demand (the Accelerator Principle), not merely by cheap credit or high corporate profit margins. Idle capacity discourages fresh industrial expansion.",
        "Vicious Cycle: Suppressed wages -> Depressed aggregate demand -> Low capacity utilization -> Deferred private capex -> Sluggish employment and wage growth.",
      ],
      conclusion:
        "Conclude that sustainable GDP growth requires a wage-led, wage-inclusive growth paradigm where real wage increments match labor productivity gains.",
    },
    modelSynopsis:
      "The proposition that wage minimization guarantees sustained corporate growth commits the classical 'fallacy of composition'. In a modern demand-constrained economy, wages represent both a production cost for an individual employer and the principal source of aggregate purchasing power for the overall market.\n\n1. The Consumption Demand Channel:\nWage-dependent households possess a significantly higher Marginal Propensity to Consume (MPC) compared to corporate entities or capital owners who hold higher savings rates. When the wage share in GDP shrinks, purchasing power concentrates in fewer hands, directly depressing mass-market consumption demand for essentials and consumer durables.\n\n2. The Investment Demand Channel:\nFirms do not invest simply because corporate profits are high or corporate taxes are cut. Under the Keynesian 'Accelerator Principle', private capital expenditure is unlocked only when existing capacity utilization crosses critical thresholds (~75-80%). In the absence of robust consumer demand, firms hoard cash or invest in financial speculation rather than greenfield factories.\n\nThus, wage suppression cannibalizes the very consumer market that corporate expansion depends upon.",
    evaluationCriteria: [
      "Explained the paradox / fallacy of composition clearly",
      "Linked to Marginal Propensity to Consume (MPC)",
      "Explained the link between consumer demand, capacity utilization, and private capex",
      "Balanced analytical clarity with economic terminology",
    ],
  },
  {
    id: "sec-20261031-q9",
    date: "2026-10-31",
    dateDisplay: "31 October 2026",
    edition: "Insights Mini SECURE",
    qNumber: "Q9",
    paper: "GS Paper 4",
    subject: "Ethics in Governance",
    topic: "Ethics in public administration, probity in governance, political neutrality of enforcement agencies, rule of law.",
    marks: 10,
    words: 150,
    suggestedTime: "7 Minutes",
    difficulty: "Moderate",
    directive: "Comment",
    reference: "Ethics and Integrity in Public Institutions / ARC-II",
    whyTheQuestion:
      "Intensified public debate regarding selective enforcement and the perceived instrumentalization of regulatory and investigative institutions against political rivals.",
    keyDemand:
      "Comment on how the conflation of justice with political expediency corrodes public trust, destroys administrative neutrality, violates the rule of law, and debases democracy into institutional vengeance.",
    question:
      "“Political accountability becomes ethically questionable when the pursuit of justice is indistinguishable from the pursuit of political advantage.” Comment. (10 Marks, 150 Words)",
    framework: {
      introduction:
        "Start with an ethical maxim: Justice must not only be done, but must manifestly and undoubtedly be seen to be done (Lord Hewart). Accountability divorced from fairness degenerates into tyranny.",
      body: [
        "The Ethical Dilemma: Legitimate accountability seeks correction, transparency, and public deterrence based on non-partisan evidence. In contrast, selective weaponization serves partisan vendetta, using procedural law to achieve political incapacitation.",
        "Ethical Hazards: Erosion of institutional credibility of investigative agencies (ED, CBI, police); subversion of the 'Rule of Law' into 'Rule by Law'; chilling effect on democratic dissent; cynicism among citizens who view anti-corruption drives as theatrical charades.",
        "Restoring Moral Probity: Institutional insulation of enforcement bodies (collegium appointments, fixed tenures); judicial oversight against selective prosecution; transparent, objective evidentiary benchmarks.",
      ],
      conclusion:
        "Quote Mahatma Gandhi on ends and means: 'The means may be likened to a seed, the end to a tree.' When justice is tainted by partisan ends, the institutional fruit is moral decay.",
    },
    modelSynopsis:
      "Genuine political accountability is the cornerstone of democratic governance. However, the moral legitimacy of accountability collapses when state enforcement mechanisms appear selective, asymmetrical, or weaponized for electoral expedience.\n\n1. Distortion of Justice:\nUnder deontological ethics (Kant), justice is a moral imperative that treats all individuals as equal before the law. When law enforcement selectively targets political dissenters while extending de facto immunity to political allies, the concept of justice is reduced from an objective moral virtue to a partisan instrument.\n\n2. Severe Ethical Ramifications:\n- Rule by Law over Rule of Law: Legal statutes become tactical weapons rather than shields of citizen rights.\n- Institutional Erosion: Civil servants and investigative agencies compromise their professional neutrality, prioritizing political survival over constitutional duty.\n- Citizen Cynicism: When anti-corruption enforcement is perceived as a partisan vendetta, public faith in justice administration evaporates.\n\nTrue accountability requires transparent, institutionalized processes independent of the political executive's electoral calculations.",
    evaluationCriteria: [
      "Distinguished genuine accountability from partisan weaponization",
      "Discussed impact on Rule of Law, institutional trust, and neutrality",
      "Integrated ethical concepts (ends vs means, Kantian justice, procedural fairness)",
      "Suggested institutional safeguards for enforcement bodies",
    ],
  },
  {
    id: "sec-20261031-q10",
    date: "2026-10-31",
    dateDisplay: "31 October 2026",
    edition: "Insights Mini SECURE",
    qNumber: "Q10",
    paper: "GS Paper 4",
    subject: "Humanitarian & Applied Ethics",
    topic: "Ethical concerns and dilemmas in international relations, humanitarian action, neutrality vs moral duty.",
    marks: 10,
    words: 150,
    suggestedTime: "7 Minutes",
    difficulty: "Analytical",
    directive: "Analyse the ethical dilemma",
    reference: "International Committee of the Red Cross (ICRC) / Geneva Conventions",
    whyTheQuestion:
      "Escalating contemporary armed conflicts and humanitarian blockades have ignited intense ethical debates over whether international humanitarian organizations and neutral states become complicit through silent neutrality.",
    keyDemand:
      "Analyze the profound tension between the functional principle of neutrality (impartial access, safety of aid workers) and the moral duty to bear witness and denounce egregious human rights violations and civilian atrocities.",
    question:
      "“Neutrality in the face of grave human suffering may itself become a form of moral indifference.” Analyse the ethical dilemma between impartiality and moral responsibility in humanitarian action. (10 Marks, 150 Words)",
    framework: {
      introduction:
        "Cite Elie Wiesel or Dante: 'The hottest places in hell are reserved for those who, in times of great moral crisis, maintain their neutrality.' State the fundamental tension at the heart of humanitarian action.",
      body: [
        "The Case for Neutrality (The Red Cross Model): Operational necessity—strict political neutrality and discretion secure physical access to conflict zones, protect aid workers, and ensure medical aid reaches victims on all sides.",
        "The Case for Moral Responsibility (The Doctors Without Borders / MSF Model): The duty of 'témoignage' (bearing witness); silent neutrality when witnessing war crimes or ethnic cleansing risks active complicity by sanitizing atrocities.",
        "The Ethical Reconciliation: Functional neutrality must never equate to moral apathy. Differentiate between tactical neutrality on battlefield logistics and principled advocacy for human dignity, international humanitarian law (IHL), and civilian protection.",
      ],
      conclusion:
        "Humanitarian agencies must balance 'practical mercy on the ground' with the courageous moral obligation to prevent the normalization of human suffering.",
    },
    modelSynopsis:
      "The paradox of neutrality in humanitarian intervention poses one of the most agonizing moral dilemmas in contemporary ethics. As Desmond Tutu famously noted, 'If you are neutral in situations of injustice, you have chosen the side of the oppressor.'\n\n1. The Rationale for Functional Neutrality:\nThe classic humanitarian doctrine (represented by the ICRC) argues that neutrality is not moral indifference, but an indispensable operational strategy. By remaining strictly apolitical and confidential, aid workers secure access across frontlines to save lives that would otherwise be abandoned if agencies were declared partisan adversaries.\n\n2. The Peril of Complicity:\nConversely, the Médecins Sans Frontières (MSF) ethic of 'bearing witness' (témoignage) asserts that silent compliance in the face of genocide, forced starvation, or deliberate civilian bombardment makes humanitarians unwitting accessories to atrocities. Silence confers impunity.\n\n3. Harmonizing the Dilemma:\nTrue ethics distinguishes between tactical neutrality (treating wounded combatants without bias) and moral neutrality. Neutrality must remain a means to relieve suffering, never an excuse to overlook evil.",
    evaluationCriteria: [
      "Contrasted functional neutrality (ICRC) vs moral responsibility/témoignage (MSF)",
      "Quoted relevant thinkers (Elie Wiesel, Desmond Tutu, or Dante)",
      "Analyzed the practical dilemma: access vs speaking truth to power",
      "Reached a balanced, ethical synthesis",
    ],
  },

  // ----------------- 30 OCTOBER 2026 ARCHIVE -----------------
  {
    id: "sec-20261030-q1",
    date: "2026-10-30",
    dateDisplay: "30 October 2026",
    edition: "Insights Daily SECURE",
    qNumber: "Q1",
    paper: "GS Paper 1",
    subject: "Geography & Ecology",
    topic: "Distribution of key natural resources across the world; environmental impact of major infrastructure projects.",
    marks: 15,
    words: 250,
    suggestedTime: "11 Minutes",
    difficulty: "Medium",
    directive: "Analyse their impacts and Explain the challenges",
    reference: "Down To Earth / Siang Dam Project Debates",
    whyTheQuestion:
      "Recent protests in Arunachal Pradesh against massive proposed multipurpose hydroelectric projects have renewed focus on river ecology, sediment dynamics, and dam decommissioning.",
    keyDemand:
      "Explain how mega dams transform natural river equilibrium; analyze upstream impacts (submergence, slope instability) and downstream impacts (estuarine salinity, silt starvation); evaluate the challenges in sustaining long-term benefits.",
    question:
      "How do large dams transform the natural functioning of river systems? Analyse their impacts on upstream and downstream regions. Explain the challenges involved in sustaining their benefits over time. (15 Marks, 250 Words)",
    framework: {
      introduction:
        "Introduce rivers as living, dynamic geomorphological conduits transporting water, sediment, and biota. Large dams fragment this longitudinal continuum, converting lotic (flowing) ecosystems into lentic (stagnant) reservoirs.",
      body: [
        "Transformation of Natural Functioning: Trapping sediment loads, disrupting thermal stratification, altering seasonal hydrographs, and obstructing anadromous/catadromous fish migration.",
        "Upstream Impacts: Reservoir-induced seismicity (RIS); submergence of fertile riverine valleys and forests; displacement of indigenous communities; elevated greenhouse emissions from decaying submerged biomass.",
        "Downstream Impacts: Coastal delta erosion and shrinking due to silt starvation; altered estuarine salinity gradients; loss of fertile flood recession agriculture; channel scouring and aquifer depletion.",
        "Challenges in Sustaining Long-Term Benefits: Reservoir sedimentation reducing dead and live storage capacity; unpredictable inflows due to glacial retreat and extreme climate anomalies; structural ageing and dam safety risks.",
      ],
      conclusion:
        "Conclude with recommendations for decommission planning, environmental flow guarantees (e-flows under Dam Safety Act 2021), and river basin-scale holistic management.",
    },
    modelSynopsis:
      "Large dams represent monumental feats of engineering that furnish critical water, irrigation, and clean hydro-power. However, they alter the natural hydrological, geomorphological, and biological equilibrium of river basins.\n\n1. Alteration of Natural River Functioning:\n- Longitudinal Fragmentation: Dams sever the river continuum, interrupting downstream nutrient flux and biological migration corridors.\n- Flow Regime Inversion: Natural peak monsoon flows are curtailed while dry-season discharges are artificially fluctuating for peak power production.\n\n2. Upstream vs Downstream Impacts:\n- Upstream: Reservoir creation inundates vast tracts of biodiversity-rich forests, destabilizes slopes in seismically sensitive mountains (e.g., Himalayas), and triggers involuntary displacement of riparian tribes.\n- Downstream: Deprived of vital sediment, downstream riverbeds undergo degradation ('hungry water' effect), deltas subside into the sea (e.g., Sundarbans, Krishna delta), and estuarine fisheries suffer.\n\n3. Challenges to Long-Term Viability:\n- Reservoir Siltation: Silt deposition drastically curtails storage capacity well before designed economic lifespans.\n- Extreme Weather Events: Glacial lake outbursts (GLOFs) and cloudbursts transform dams from protective flood mitigators into flood hazards.\n\nAdopting ecological flow standards and strict enforcement of the Dam Safety Act 2021 are indispensable.",
    evaluationCriteria: [
      "Distinguished lotic vs lentic systems and sediment trapping",
      "Clear upstream and downstream impact matrix",
      "Explained sustainability bottlenecks (siltation, climate risks, ageing dams)",
      "Referenced Dam Safety Act 2021 and environmental flows",
    ],
  },
  {
    id: "sec-20261030-q2",
    date: "2026-10-30",
    dateDisplay: "30 October 2026",
    edition: "Insights Daily SECURE",
    qNumber: "Q2",
    paper: "GS Paper 1",
    subject: "Indian Culture & Architecture",
    topic: "Salient aspects of Art Forms, Literature and Architecture from ancient to modern times.",
    marks: 15,
    words: 250,
    suggestedTime: "11 Minutes",
    difficulty: "Moderate",
    directive: "Discuss with suitable examples",
    reference: "Indian Express / Archaeological Survey of India (ASI)",
    whyTheQuestion:
      "Recent engineering studies revealing seismic-resistant joinery and acoustic sciences in Chola, Hoysala, and Mughal monuments highlight how indigenous scientific knowledge shaped Indian architectural heritage.",
    keyDemand:
      "Discuss the interplay between scientific/technological mastery (metallurgy, geometry, acoustics, hydraulic engineering, structural mechanics) and the aesthetic evolution of Indian architecture across eras.",
    question:
      "Discuss the influence of scientific and technological advancements on the evolution of Indian architecture, with suitable examples. (15 Marks, 250 Words)",
    framework: {
      introduction:
        "Frame Indian architectural evolution as an empirical synthesis of religious iconography and advanced technological knowledge—spanning mathematics (Sulba Sutras), metallurgy, hydraulic engineering, and structural masonry.",
      body: [
        "Ancient Hydraulic & Urban Engineering: Harappan drainage systems, dockyards at Lothal, and stepwells (Baolis) of Gujarat demonstrating sophisticated water harvesting.",
        "Geometric & Structural Mastery in Temple Architecture: Vastushastra principles and interlocking dry-stone masonry without mortar; corbelling techniques; monolithic rock-cutting at Ellora (Kailash temple) requiring precise top-down stereotomy.",
        "Metallurgy and Structural Astronomy: Rust-resistant iron beams in Konark Sun Temple; Iron Pillar of Mehrauli; sundial calibration at Jantar Mantar.",
        "Indo-Islamic Engineering Innovations: True arches and domes using lime mortar; acoustic engineering at Gol Gumbaz (whispering gallery); passive cooling techniques and water channels in Mughal palaces.",
      ],
      conclusion:
        "Indian architectural heritage stands as a testament to indigenous engineering ingenuity, offering timeless lessons in sustainable, climate-resilient vernacular construction.",
    },
    modelSynopsis:
      "The architectural landscape of India is not merely an artistic chronicle, but a continuous record of indigenous scientific and technological breakthroughs across millennia.\n\n1. Urban Planning and Hydraulic Science:\n- Indus Valley Civilization: Pioneered grid-iron town planning, underground sewer networks with inspection traps, and tidal dock engineering at Lothal.\n- Water Architecture: Stepwells such as Rani ki Vav synthesized structural subterranean arches with hydraulic pressure balancing.\n\n2. Stone Mechanics and Rock Excavation:\n- Kailash Temple (Ellora): Accomplished top-down monolithic subtractive carving, requiring intricate stereotomy, rock-stress calculations, and precise volumetric planning.\n- Dravidian Shikhara Engineering: The Brihadisvara Temple at Thanjavur utilized interlocking dry-masonry and an 80-tonne granite capstone placed via earthen inclined planes.\n\n3. Metallurgy and Masonry Innovations:\n- Eastern Indian Temples: The Konark Sun Temple incorporated forge-welded iron beams to span massive stone lintels centuries before European industrial metallurgy.\n- Indo-Islamic Architecture: Introduction of lime-mortar technology facilitated the construction of true arches, double domes (Humayun's Tomb), and the legendary whispering acoustics of Gol Gumbaz in Vijayapura.",
    evaluationCriteria: [
      "Spanned ancient (Harappa), classical (Chola/Ellora), and medieval (Mughal/Deccan) eras",
      "Highlighted specific sciences: metallurgy, hydraulics, acoustics, geometry",
      "Gave concrete historical monuments as evidence",
      "Connected historical engineering with modern relevance",
    ],
  },
];



